module.exports = __webpack_public_path__ + "img/icon_mid_pt.7130e5de.png";